import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { AuthContext } from "../../../../../Context/AuthContext";

export const TrainingNavbar = ({ openThemeModal }) => {
  const { user } = useContext(AuthContext);
  return (
    <div className="content">
      <div className="container-fluid">
        <div className="row">
          <div className="col-12">
            <div className="page-title-box-two">
              <h4 className="page-title"></h4>
              <h1 className="welcome_text">TRAINING MANAGEMENT</h1>
              <div className="clearfix"></div>
            </div>
          </div>
        </div>

        <div>
          <nav
            className="navbar navbar-light navbar-expand-md bg-faded justify-content-center"
            style={{
              boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.075)",
            }}
          >
            <a href="/" className="navbar-brand d-flex w-50 mr-auto"></a>
            <ul className="navbar-nav w-100 ml-auto justify-content-center">
              <li className="nav-item ml-auto">
                <Link
                  className="nav-link"
                  to="/dashboard/training"
                  style={{ borderRight: "3px solid #243050" }}
                >
                  MUNCH AND LEARN
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className="nav-link"
                  to="/dashboard/training/theme-of-week"
                  style={{ borderRight: "3px solid #243050" }}
                >
                  THEME OF THE WEEK
                </Link>
              </li>
            </ul>
            <div
              className="navbar-collapse collapse w-100"
              id="collapsingNavbar3"
            >
              <ul className="nav navbar-nav ml-auto w-100 justify-content-end">
                <li className="nav-item ml-auto"></li>
              </ul>
            </div>
          </nav>
          <br></br>
          <div className="table-title">
            <div className="row">
              <div className="col-sm-6">
                <h2>
                  <b> THEME OF THE WEEK </b>{" "}
                </h2>
              </div>
              <div className="col-sm-6">
                {/* <a href="/" className="btn nt-button-color-action trigger-btn">
                  <span className="fa fa-file-export"></span>
                  &nbsp;&nbsp; Export
                </a>
                <a href="/" className="btn nt-button-color-action trigger-btn">
                  <span className="fa fa-file-import"></span>
                  &nbsp;&nbsp; Import
                </a> */}
                {(user.data.user.roles &&
                  user.data.user.roles.name !== "line manager") ||
                user.data.user.roles.name !== "employee" ? (
                  <div
                    onClick={openThemeModal}
                    className="btn nt-button-color-action trigger-btn"
                  >
                    <span className="fa fa-plus"></span>
                    &nbsp;&nbsp; Add New
                  </div>
                ) : null}

                {/* <Link
                  to="/dashboard/training/view-theme"
                  className="btn nt-button-color-action trigger-btn"
                >
                  <span className="fa fa-eye"></span>
                  &nbsp;&nbsp; View All
                </Link> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/container/dashboard/trainingmanagement/themeoftheweek/reusedcomponent/navbar.js